import { Component, Input, NgZone, OnDestroy, OnInit } from "@angular/core";
import { ChartData, ChartOptions, ChartType } from "chart.js";
import {
  AnalyticsService,
  AuthorizationService,
  ExportService,
  LoggingService,
  UserRemovedData,
  ToastrService,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import {
  ChartDefinition,
  ChartDefinitions,
} from "app/analytics/chartDefinitions.config";
import {
  ManualsDownloadedConfig,
  UserAnalyticConfiguration,
} from "app/shared/model/charts/user-analytic-configurations.model";

//TODO: This chart is incomplete, not in use

@Component({
  selector: "account-status-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class AccountStatusChartComponent
  extends BaseChartLogic<ManualsDownloadedConfig, UserRemovedData>
  implements OnInit, OnDestroy
{
  //I am here, change type for DownloadedManualsConfig
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;

  private DataLoaded: any = {
    Normal: false,
    Removed: false,
    Locked: false,
  };

  public accountStatusData: ChartData<"pie"> = {
    labels: ["Active", "Locked", "Removed"],
    datasets: [{ data: [65, 59, 22], label: "Account Status" }],
  };
  public accountStatusChartOptions: ChartOptions = {
    responsive: true,
    aspectRatio: 2,
  };
  public accountStatusChartType: ChartType = "pie";

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsDownloadedConfig,
      _ngZone
    );

    // this.handleDataSubscription(
    //       this.analyticsService.removedUsersDataChange
    //     );

    this.analyticsService.usersRemovedDataChange.subscribe((data) => {
      this.isLoading = false;
      //sum all the data points
      let total = 0;
      data.DataPoints.forEach((element) => {
        total += element.Total;
      });
      this.accountStatusData.datasets[0].data[2] = total;
      this.MarkLoaded("Removed");
      this.hasData = true;
    });

    this.analyticsService.usersLockedDataChange.subscribe((data) => {
      //sum all the data points
      let total = 0;
      data.DataPoints.forEach((element) => {
        total += element.Total;
      });
      this.accountStatusData.datasets[0].data[1] = total;
      this.MarkLoaded("Locked");
      this.hasData = true;
    });

    this.analyticsService.usersTotalDataChange.subscribe((data) => {
      //sum all the data points
      let total = 0;
      total = data.DataPoints[0].Total;
      this.accountStatusData.datasets[0].data[0] = total;
      this.MarkLoaded("Normal");
      this.hasData = true;
    });
  }

  private MarkLoaded(dataType: string): void {
    switch (dataType) {
      case "Normal":
        this.DataLoaded.Normal = true;
        break;
      case "Removed":
        this.DataLoaded.Removed = true;
        break;
      case "Locked":
        this.DataLoaded.Locked = true;
        break;
    }
    if (
      this.DataLoaded.Normal &&
      this.DataLoaded.Removed &&
      this.DataLoaded.Locked
    ) {
      this.isLoading = false;
    }
  }

  dataPointKey: string = "Total"; //I am here
  protected getDataPointDisplayValue(dataPoint: any): void {
    //I am here
  }

  buildFilterSettings(): void {
    //I am here
  }

  refreshData(): void {
    this.isLoading = true;
    this.DataLoaded.Normal = false;
    this.DataLoaded.Total = false;
    this.DataLoaded.Locked = false;
    this.filterSettings.FilterByStartDate = this.startDate;
    this.filterSettings.FilterByEndDate = this.endDate;
    this.filterSettings.FilterByDate = this.startDate;
    this.loggingService.log("Getting App Usage Data");
    this.analyticsService.getLockedUsersData(this.filterSettings);
    this.analyticsService.getRemovedUsersData(this.filterSettings);
    this.analyticsService.getTotalUsersData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
